import { HEATMAP_STATE } from '@/libs/constants'

export function normalizeHeatmapListData (list, noApply) {
  const rankingList = []

  for (let i = 0, iLen = list.length; i < iLen; i++) {
    const ranking = normalizeHeatmapData(list[i], noApply)
    rankingList.push(ranking)
  }

  return rankingList
}

export function normalizeHeatmapData (item, noApply) {
  item.isExistHeatmap = true
  item.heatmapState = HEATMAP_STATE.NONE
  if (item.baApply && item.baApply._id) {
    item.isExistHeatmap = true
    item.heatmapAid = item.baApply._id
    item.heatmapState = item.baApply.state // 실제 run
    item.heatmapUiState = item.baApply.uiState // 세부 분류
    if (item.baApply.state === HEATMAP_STATE.RUN && item.baApply.endDate && new Date(item.baApply.endDate) < new Date()) {
      item.heatmapState = HEATMAP_STATE.ENDBYANALYSISDATE
      item.heatmapUiState = HEATMAP_STATE.ENDBYANALYSISDATE
    }
  }
  if (noApply) {
    item.heatmapState = item.state // 실제 run
    item.heatmapUiState = item.uiState // 세부 분류
  }
  return item
}
